module.exports = __webpack_public_path__ + "coffee.759140184d8763be2263.jpg";


//////////////////
// WEBPACK FOOTER
// D:/NewPhoenixScrum/PhoenixScrum/Main/CitizenSevicesEx/CSClient/CSClient/client/assets/img/coffee.jpg
// module id = ../../../../../client/assets/img/coffee.jpg
// module chunks = styles